import { useNavigator } from '@repo/toolkit/use-navigator'
import { MeetingPointIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTripAddress } from '../../api/trip-addresses/create-trip-address'
import UserNavBar from '../../components/elements/nav-bar'
import TripAddressForm from '../../components/pages/trip-addresses/trip-address-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const TripAddressCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTripAddress,
    onError: showAxiosError,
    onSuccess: () => toast.success('Lieu de RDV créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un lieu de RDV'} icon={MeetingPointIcon} />
      <div className={'h-4'} />
      <TripAddressForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(values)
            navigate(Paths.TRIP_ADDRESS_UPDATE_PAGE.replace(':id', res.id.toString()), {
              replace: true
            })
          },
          onCancel: () => back(Paths.TRIP_ADDRESS_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default TripAddressCreatePage
